import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import "stylesheets/components/common/SessionExpiringModal.css";
import Modal from "../common/Modal";
import CustomButton from "../common/CustomButton";
import Propulator from "higher-order/Propulator";
import autobind from "autobind-decorator";

@observer
class SessionExpiringModalView extends React.Component {
    static propTypes = {
        expiringModal: PropTypes.object
    }

    @autobind
    handleExtendSession(e) {
        this.props.dispatcher.emit("SESSION_EXTEND");
    }

    @autobind
    handleEndSession(e) {
        this.props.dispatcher.emit("SESSION_END");
    }

    render() {
        const model = this.props.expiringModal;
        // TODO: Modal button area as a subsection you can add?
        return (
            <Modal className="session-expiring-modal" title="Session Inactivity" modalKey="sessionExpiring" isOpen={model.isOpen}>
                <div className="session-expiration-info">
                    <h4>Your session is about to expire!</h4>
                    <p>For your safety we will log your account if you are not interacting with Gradifi for a long period of time.</p>
                    <p><strong>To prevent this click anywhere on the screen or press "I'm here" below.</strong></p>
                    <p><strong>Your session will expire in {model.remainingTime} seconds.</strong></p>
                </div>
                <div className="session-expiration-modal-buttons">
                    <CustomButton text="I'm here" className="session-extend" onClick={this.handleExtendSession} />
                    <CustomButton text="Logout" className="session-logout" onClick={this.handleEndSession} />
                </div>
            </Modal>
        );
    }
}

export default Propulator(SessionExpiringModalView, {
    "sessionStore": ["expiringModal"]
});
